<section
  *ngIf="showAllShippingInformation"
  class="shipping-information-section"
>
  <h2 data-cy="shipping-information-text">
    {{ 'i18n.productDetail.shippingInfo.shippingInformation' | translate }}
  </h2>
  <ion-row>
    <ion-col size-xl="4" size-lg="4" size-md="4" size-xs="12" size-sm="12">
      <section
        *ngIf="showShippingDetails"
        class="desktop-tablet-shipping-details"
      >
        <h4 data-cy="shipping-details-text">
          {{ 'i18n.productDetail.shippingInfo.shippingDetails' | translate }}
        </h4>
        <ng-container *ngTemplateOutlet="ShippingDetails"></ng-container>
      </section>
      <section *ngIf="showShippingDetails" class="mobile-shipping-details">
        <app-usf-expandable-panel
          title="{{
            'i18n.productDetail.shippingInfo.shippingDetails' | translate
          }}"
          [addBottomBorder]="true"
          noBorders
        >
          <ng-container *ngTemplateOutlet="ShippingDetails"></ng-container>
        </app-usf-expandable-panel>
      </section>
    </ion-col>
    <ion-col size-xl="4" size-lg="4" size-md="4" size-xs="12" size-sm="12">
      <section
        *ngIf="showStorageInformation"
        class="desktop-tablet-storage-information"
      >
        <h4 data-cy="desktop-storage=information-text">
          {{ 'i18n.productDetail.shippingInfo.storageInformation' | translate }}
        </h4>
        <ng-container *ngTemplateOutlet="StorageInformation"></ng-container>
      </section>
      <section
        *ngIf="showStorageInformation"
        class="mobile-storage-information"
      >
        <app-usf-expandable-panel
          title="{{
            'i18n.productDetail.shippingInfo.storageInformation' | translate
          }}"
        >
          <ng-container *ngTemplateOutlet="StorageInformation"></ng-container>
        </app-usf-expandable-panel>
      </section>
    </ion-col>
    <ion-col size-xl="4" size-lg="4" size-md="4" size-xs="12" size-sm="12">
      <section
        class="desktop-tablet-manufacturer"
        *ngIf="isManufacturerSectionDefined"
      >
        <h4 data-cy="manufacturer-details-text">
          {{
            'i18n.productDetail.shippingInfo.manufacturerDetails' | translate
          }}
        </h4>
        <ng-container *ngTemplateOutlet="ManufacturerDetails"></ng-container>
      </section>
      <section class="mobile-manufacturer">
        <app-usf-expandable-panel
          title="{{
            'i18n.productDetail.shippingInfo.manufacturerDetails' | translate
          }}"
        >
          <ng-container *ngTemplateOutlet="ManufacturerDetails"></ng-container>
        </app-usf-expandable-panel>
      </section>
      <span
        class="section-divider"
        data-cy="section-divider-line"
        *ngIf="isManufacturerSectionDefined && isClassificationSectionDefined"
      ></span>
      <section
        class="desktop-tablet-classification-details"
        *ngIf="isClassificationSectionDefined"
      >
        <h4 data-cy="shipping-info-classification-details-text">
          {{
            'i18n.productDetail.shippingInfo.classificationDetails' | translate
          }}
        </h4>
        <ng-container *ngTemplateOutlet="ClassificationDetails"></ng-container>
      </section>
      <section class="mobile-classification-details">
        <app-usf-expandable-panel
          title="{{
            'i18n.productDetail.shippingInfo.classificationDetails' | translate
          }}"
          [addBottomBorder]="true"
        >
          <ng-container
            *ngTemplateOutlet="ClassificationDetails"
          ></ng-container>
        </app-usf-expandable-panel>
      </section>
    </ion-col>
  </ion-row>
</section>
<ng-template #ShippingDetails>
  <ul>
    <ng-container *ngFor="let shippingDetail of shippingDetails">
      <li
        [attr.data-cy]="
          'shipping-details-' + shippingDetail?.keyLabel + '-list'
        "
        *ngIf="shippingDetail.visible"
        [id]="
          'pdp-shippingDetail-' +
          shippingDetail.keyLabel +
          '-' +
          product?.productNumber
        "
      >
        <label data-cy="shipping-details-label-text">
          {{ shippingDetail.keyLabel | translate }}:&nbsp;</label
        >{{ shippingDetail.value }}
      </li>
    </ng-container>
  </ul>
</ng-template>
<ng-template #StorageInformation>
  <ul>
    <ng-container *ngFor="let storageInfo of storageInfos">
      <li
        [attr.data-cy]="'storage-info-' + storageInfo?.value + '-list'"
        *ngIf="storageInfo.visible"
        [id]="
          'pdp-storageInfo-' +
          storageInfo.keyLabel +
          '-' +
          product?.productNumber
        "
      >
        <label data-cy="storage-info-label-text">
          {{ storageInfo.keyLabel | translate }}:&nbsp;</label
        >{{ storageInfo.value }}
      </li>
    </ng-container>
  </ul>
</ng-template>
<ng-template #ManufacturerDetails>
  <ul>
    <li
      data-cy="manufacturer-details-list"
      [id]="'pdp-manufacturer-details-' + product?.productNumber"
    >
      <label *ngIf="isManufacturerNameDefined">
        {{ 'i18n.productDetail.manufacturer' | translate }}</label
      >
      {{ productDetailManufacturerName }}
      {{ productSummaryBrand }}
    </li>
    <li
      data-cy="manufacturer-product-number-list"
      [id]="'pdp-manufacturer-product-number-' + product?.productNumber"
    >
      <label *ngIf="product?.detail?.manufacturerProductNumber">
        {{ 'i18n.productDetail.manufacturerProductNum' | translate }}
      </label>
      {{ productDetailManufacturerProductNumber }}
    </li>
  </ul>
</ng-template>
<ng-template #ClassificationDetails>
  <ul>
    <li
      [attr.data-cy]="
        'classification-class-' + product?.productNumber + '-list'
      "
      *ngIf="isClassificationClassDefined"
    >
      <label data-cy="classification-class-label-text">
        {{ 'i18n.productDetail.class' | translate }}</label
      >
      {{ product?.summary?.classCode }} -
      {{ product?.summary?.classDescription }}
    </li>
    <li
      [attr.data-cy]="
        'classification-category-' + product?.productNumber + '-list'
      "
      *ngIf="isClassificationCategoryDefined"
    >
      <label data-cy="classification-category-label-text">
        {{ 'i18n.productDetail.category' | translate }}</label
      >
      {{ product?.summary?.categoryCode }} -
      {{ product?.summary?.categoryDescription }}
    </li>
    <li
      [attr.data-cy]="
        'classification-group-' + product?.productNumber + '-list'
      "
      *ngIf="isClassificationGroupDefined"
    >
      <label data-cy="classification-group-label-text">{{
        'i18n.productDetail.group' | translate
      }}</label>
      {{ product?.summary?.groupCode }} -
      {{ product?.summary?.groupDescription }}
    </li>
  </ul>
</ng-template>
